<template>
    <div style="width:100%;padding-left:10px">
        <div style="margin-bottom: 20px">
        
        <h1 class="title is-4">
            <s-button icon="undo" @onclick="$emit('close')" label="" theme="is-warning"/>&nbsp;
            <s-l id="configMembre_title">Configuration des tags de vos membre</s-l>
            <div style="float: right">
                 <s-you-tube id="video_tag" :club="club"  />
            </div>
        </h1>
        </div>
        <h2 class="title is-6">
            <s-l id="congifMembre_desc">Customisez les tags pour vos membres</s-l>
        </h2>
        <div  style="width:100%;border: thin solid black;padding: 10px;">
            <div style="width:50%;display:inline-block;">
            <div>
            
                <label>
                    Nom du champ :
                </label>                
                <input type="text" v-model="custom.label" class="input is-primary is-rounded is-small" style="width: 200px"/>
                
                <div class="idField" v-if="custom.id==null">id : {{fieldId}}</div>
                <div class="idField" v-if="custom.id!=null">id : {{custom.id}}</div>
            </div>
            <div>                
                Type de champ :
                <label class="select is-primary is-rounded is-small">
                <select v-model="custom.type">
                    <option  value="text">Texte</option>
                    <option value="number">Nombre</option>
                    <option value="date">Date</option>
                    <option value="radio">Liste de choix unique</option>
                   
                </select> 
                </label>
            </div>
            <label class="checkbox">
                Filtrer : <input type="checkbox" class="checkbox" v-model="custom.filter" />
            </label><br/>
                <label class="checkbox">
                Privé : <input type="checkbox" class="checkbox" v-model="custom.private" />
            </label><br/>
            <s-button icon="plus" label="Ajouter le champ" theme="is-success is-small" @onclick="addField"
                v-show="custom.id==null"
                :disabled="this.custom.label.length<3"/>
            
            <s-button icon="times-circle" label="Annuler" theme="is-warning is-small" @onclick="cancelField"
                v-show="custom.id!=null"/>&nbsp;&nbsp;
            <s-button icon="save" label="Enregistrer" theme="is-success is-small" @onclick="setField"
                v-show="custom.id!=null"/>&nbsp;&nbsp;
            <s-button icon="trash" label="Supprimer" theme="is-danger is-small" @onclick="deleteField(custom.id)"
                v-show="custom.id!=null"/>
            </div>
           
             <div style="width:50%;display:inline-block;vertical-align:top" v-show="custom.type=='radio' || custom.type=='checkbox'">
                
                <b>Les valeurs de la liste :</b><br/>
                <input v-model="newValue" class="input is-primary is-small is-rounded"
                        style="width: 150px"/>&nbsp;
                <s-button icon="plus" @onclick="addValue()" theme=" is-success is-small" label=""/> 
                <br/>
                <div v-if="custom.values.length>0">
                
                <div v-for="(value, index) in custom.values" style="padding:2px">  
                       <div :class="classDefault(index)" v-on:click="setValueDefault(index)">{{index}} </div>
                       <input v-model="custom.values[index]" class="input is-primary is-small"
                        style="width: 150px"/>&nbsp;
                        <s-button icon="trash" @onclick="deleteValues(index)" label="" theme="is-danger is-trash is-small"/>
                </div>
                </div>
            </div>
            
        </div>
        <br/>
  
        <table style="width:100%" border="1" class="custom">
            <tr >
                <th style="width:30%">
                    Nom du champ
                </th>
                <th style="width:30%">Type</th>
                <th style="width:10%">Valeurs</th>
                <th  style="width:10%">Filtrer</th>
                <th style="width:10%">Privé</th>
            </tr>
            <tr v-for="customItem in club.customs" class="edit" v-on:click="edit(customItem)">
                <td>{{customItem.label}}
                  <div class="idField">{{customItem.id}}</div>  
                </td>
                <td>{{getType(customItem.type)}}</td>
                <td style="text-align:right;padding:5px"> 
                     <div v-for="value in customItem.values" style="padding:2px">  
                        {{value}} &nbsp;
                    </div>
                </td>
                <td><input type="checkbox" class="checkbox" v-model="customItem.filter" /> </td>
                <td><input type="checkbox" class="checkbox" v-model="customItem.private" /> </td>

            </tr>
        </table>
        
         </div>
</template>
<style scoped>
    .idField {
        font-size: 12px;
        
    }
    .custom td {
        text-align: center;
         padding: 5px;
    }
    .custom th {
        text-align: center;
        padding: 5px;
    }
    .edit:nth-child(even) {
        background-color: rgb(236, 241, 211)
    }

    .edit:hover {
        background-color: rgb(196, 243, 102);
        cursor: pointer;
    }
    .valueDefault:hover {
        cursor: pointer;
    }
    .valueDefault {
        border-radius: 20px;
        background-color: silver;
        display: inline-block;
        padding: 5px;
        width: 35px;
        height: 30px;
        margin-right: 20px;
        text-align: center;
        font-weight: bold;
    }
    .selected {
        background-color: rgb(159, 238, 156);
        color: white;
       
    }
   
</style>
<script>
import club_fct from "@/firebase/club"
export default {
    props: ["club"],
    computed: {
        fieldId: {
        get() {
            if (this.custom.label != "")
                return (this.$StringToId(this.custom.label).toUpperCase());
            else   
                return "non défini"
            },
        }
        
    },
    data() {
        return {
            newValue: "",
            custom: {
                id: null,
                label :"",
                type: "text",
                filter: true,
                private: true,
                values:[],
                valuesDefault: null
            },
            customs: {}
        }
    },
    methods: {
        setValueDefault(index) {
            
           if (this.custom.type=="radio") {
                if (this.custom.valuesDefault == index) {
                    this.custom.valuesDefault=null
                }
                else {
                    this.custom.valuesDefault=index
                }
            }
        },
        classDefault(index) {
                if (this.custom.valuesDefault==null)
                    return "valueDefault";
                else if (Array.isArray(this.custom.valuesDefault)) {
                    if (this.custom.valuesDefault.indexOf(index)!=-1)
                        return "valueDefault selected";
                    else
                         return "valueDefault notSelected";
                }
                else if (this.custom.valuesDefault == index)
                    return "valueDefault selected";
                else
                    return "valueDefault notSelected";

        },
        getType(value) {
            if (value == 'radio') 
                return 'Liste avec choix unique';
            else
                return value;
        },
        deleteValues(index) {
            this.custom.values.splice(index, 1);
            this.save();
        },
        addValue() {
            this.custom.values.push(this.newValue);
            this.newValue = "";
            this.save();
        },
        cancelField() {
            var custom = {
                id: null,
                label :"",
                type: "text",
                filter: true,
                private: true,
                values:[]
            }
            this.newValue = "";
            this.custom = JSON.parse(JSON.stringify(custom));
        },
        setField() {
            
            this.club.customs[ this.custom.id] = this.custom;
            this.save();
            this.cancelField();
        },
        addField() {
            this.custom.id = this.fieldId;
            this.customs[this.fieldId] = JSON.parse(JSON.stringify(this.custom));
            this.club.customs = JSON.parse(JSON.stringify(this.customs));
            this.cancelField();
            this.save();
        },
        deleteField(key) {
            delete this.customs[key];
            this.club.customs = JSON.parse(JSON.stringify(this.customs));
            this.save();
        },
        edit (customEdit) {
            this.custom = customEdit;
        },
        save() {
            club_fct.object.set(this.club, ()=>{

            });
        }
    },
    mounted() {
        this.customs = this.club.customs;
    }
}
</script>